import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  {
    drawer: {
      width: 240,
      flexShrink: 0,
    },
    drawerPaper: {
      width: 240,
    },
    drawerHeader: {
      padding: '0 14px',
      minHeight: 48,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      '& $headerGrid': {
        margin: '6px',
      },
      '& $logoItem': {
        justifyContent: 'center',
        position: 'relative',
        alignItems: 'center',
        display: 'flex',
      },
      '& $closeItem': {
        position: 'relative',
        display: 'flex',
      },
      '& button': {
        width: '50px',
      },
    },
    headerGrid: {},
    logoItem: {},
    closeItem: {},
  },
  { name: 'sideBar' },
);

export default useStyles;
